module.exports = __webpack_public_path__ + "img/youshi.d326e6fa.png";